/*
 * Scenario: rewrite-single
 *
 * Simuliert einen kompletten Agent-Turn mit einem Rewrite-Vorschlag auf
 * dem Paragraph, in dem der Cursor steht. Nach User-Entscheidung kommt
 * eine kurze Reaktion des Agents (reaktives Scenario via wait()).
 *
 * Eventsequenz:
 *   session     — mock-Session-ID
 *   thinking    — "Let me take a look…"
 *   thinkingDone
 *   toolCall    — read_section (simuliert)
 *   toolResult  — 3 paragraphs
 *   proposeRewrite — echter Vorschlag mit $cursor.paragraphId / $cursor.version
 *   done        — Turn Ende → ReviewController flushed und startet Review
 *   (User entscheidet A/R, ReviewController ruft transport.reportActionDone)
 *   delta       — Reaktion basierend auf applied/rejected
 *   done
 */

import { emit, wait, resolve } from './_helpers.js'

export const name = 'rewrite-single'
export const description = 'Single rewrite proposal on the paragraph under the cursor.'

export async function run(state) {
    const toolCallId = 'tu_rw_' + Date.now().toString(36)

    await emit(state, 'session', { sessionId: 'mock-rewrite-single' }, 0)
    await emit(state, 'thinking', { text: 'Let me take a look at this paragraph…' }, 300)
    await emit(state, 'thinkingDone', {}, 200)
    await emit(state, 'toolCall', { toolCallId: 'tu_read_1', tool: 'read_section', input: {} }, 150)
    await emit(state, 'toolResult', { toolCallId: 'tu_read_1', tool: 'read_section', summary: 'section read' }, 200)

    const paragraphId = resolve(state, '$cursor.paragraphId')
    const originalText = resolve(state, '$cursor.text')
    const baseVersion = resolve(state, '$cursor.version')

    await emit(state, 'proposeRewrite', {
        toolCallId,
        paragraphId,
        baseVersion: typeof baseVersion === 'number' ? baseVersion : undefined,
        originalText: typeof originalText === 'string' ? originalText : '(paragraph text here)',
        newText: 'It was a grey November morning. The mist lay heavy on the hills and pressed against the windows like a soft, cold hand.',
        reason: 'Mood sharpened — sensory detail added.'
    }, 400)
    await emit(state, 'done', { usage: {} }, 200)

    // Auf User-Entscheidung warten (ReviewController meldet via reportActionDone)
    try {
        const info = await wait(state, toolCallId, 5 * 60 * 1000)
        const reaction = info.result === 'applied'
            ? 'Great — I kept the new phrasing. Want me to look at the next paragraph?'
            : info.result === 'version_mismatch'
                ? 'Paragraph was changed in the meantime — I will re-read and try again.'
                : 'Okay, I left it as it was. Anything else to try?'
        await emit(state, 'delta', { text: reaction }, 300)
        await emit(state, 'done', { usage: {} }, 100)
    } catch (err) {
        // Timeout oder Abort — still, Mock-Transport kuemmert sich
    }
}
